import { type Context, createContext } from 'react';

import {
  PanelSizesWithUnit,
  PanelChildren,
} from '../types/shared-panel-types.js';

export interface ParentPanelContextProps {
  parentPanelWidth: number;
  sizes: PanelSizesWithUnit;
  sortedPanels: PanelChildren;
}

/**
 * The PanelsContext holds all the information needed for managing the state of
 * a group of panels and add the event listeners for resizing to the resize handles.
 */
export const ParentPanelContext: Context<ParentPanelContextProps> =
  createContext<ParentPanelContextProps>({
    parentPanelWidth: -1,
    sizes: {},
    sortedPanels: [],
  });
ParentPanelContext.displayName = 'ParentPanelContext';
